import {
  ProductGetResDTO,
  ProductPostReqDTO,
  ProductPutReqDTO,
} from "../api/product-dto.js";

/**
 * Product 모델 정의
 * 프론트엔드에서 사용할 Product 타입
 */
export interface Product {
  id: string;
  nameKo: string;
  nameEn?: string;
  imageUrl?: string;
  numOfArticles: number;
  createdAt: string;
  updatedAt: string;
}

/**
 * DTO를 Product 모델로 변환하는 함수
 */
export const toProduct = (dto: ProductGetResDTO): Product => {
  return {
    id: dto.id,
    nameKo: dto.nameKo,
    nameEn: dto.nameEn,
    imageUrl: dto.imageUrl,
    numOfArticles: dto.numOfArticles,
    createdAt: dto.createdAt,
    updatedAt: dto.updatedAt,
  };
};

/**
 * Product 모델을 POST 요청 DTO로 변환하는 함수
 */
export const toProductPostReqDTO = (
  product: Omit<Product, "id" | "createdAt" | "updatedAt">,
): ProductPostReqDTO => {
  return {
    nameKo: product.nameKo,
    nameEn: product.nameEn,
    imageUrl: product.imageUrl,
    numOfArticles: product.numOfArticles,
  };
};

/**
 * Product 모델을 PUT 요청 DTO로 변환하는 함수
 */
export const toProductPutReqDTO = (
  product: Partial<Product> & { id: string },
): ProductPutReqDTO => {
  return {
    id: product.id,
    nameKo: product.nameKo,
    nameEn: product.nameEn,
    imageUrl: product.imageUrl,
    numOfArticles: product.numOfArticles,
    updatedAt: product.updatedAt || new Date().toISOString(),
  };
};
